module.exports = {"play":"playToggle","volume":"volumePanel","seekbar":"progressControl","timer":"remainingTimeDisplay","playbackrates":"playbackRateMenuButton","fullscreen":"fullscreenToggle"}


//////////////////
// WEBPACK FOOTER
// ./src/components/Reuseables/Controls.json
// module id = 1539
// module chunks = 0